import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48995c91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Blogs", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 1. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Money and Bitcoin, Keys and Coins")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 2. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Bitcoin: A tool for Social Justice")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 3. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Bitcoin – Gold version 2.0")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 4. ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("The Proof-of-Work train")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 5. ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Bitcoin, Climate Change and The Unstoppable Rise of Consumerist Culture")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 6. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("\"Bitcoin is Responsibility-Go-Up Technology\" - Svetski")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 7. ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Kings of Bitcoin by Maali Marvin")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 8. ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Miniaturized Nuclear Energy by Maali Marvin")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 9. ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Pleb-onomics by Maali Marvin")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 10. ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Monetary Theory on Steroids by Maali Marvin")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 11. ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Bitcoin at $100k")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 12. ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Bitcoin is the Key to More of Nature's Secrets")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 13. ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("The Untold Wonders of Deflationary Economics")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 14. ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("The Mathematics of Bitcoin – A Tale of Ants and Difficulty Adjustment")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_3,
          _createVNode(_component_router_link, { to: "/blog/1" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_5,
          _createVNode(_component_router_link, { to: "/blog/2" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_7,
          _createVNode(_component_router_link, { to: "/blog/3" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_9,
          _createVNode(_component_router_link, { to: "/blog/4" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_11,
          _createVNode(_component_router_link, { to: "/blog/5" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_13,
          _createVNode(_component_router_link, { to: "/blog/6" }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_15,
          _createVNode(_component_router_link, { to: "/blog/7" }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_17,
          _createVNode(_component_router_link, { to: "/blog/8" }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_19,
          _createVNode(_component_router_link, { to: "/blog/9" }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_21,
          _createVNode(_component_router_link, { to: "/blog/10" }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_23,
          _createVNode(_component_router_link, { to: "/blog/11" }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_25,
          _createVNode(_component_router_link, { to: "/blog/12" }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_27,
          _createVNode(_component_router_link, { to: "/blog/13" }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("h3", null, [
          _hoisted_29,
          _createVNode(_component_router_link, { to: "/blog/14" }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}